var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.993,
    height: 12.786,
    viewBox: "0 0 8.993 12.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5793",
    "data-name": "Grupo 5793",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8473",
    "data-name": "Caminho 8473",
    d: "M220.552,93.215l3.062,3.027a.748.748,0,0,1-1.056,1.06l-1.315-1.32c-.22-.221-.4-.147-.4.163v5.5a.747.747,0,1,1-1.493,0v-5.5c0-.309-.178-.383-.4-.163L217.64,97.3a.748.748,0,0,1-1.056-1.06l3.036-3.025a.663.663,0,0,1,.932,0Zm-4.2-2.111a.749.749,0,1,1,0-1.5h7.494a.749.749,0,1,1,0,1.5Z",
    transform: "translate(-215.602 -89.605)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.a0f75d391e4025b5ac5cca24dcbc3f1e.svg";
export { ForwardRef as ReactComponent };